export const CONFIRMATION_TITLE = "Confirmation";
export const LEFT_BUTTON_TEXT = "Stay On This Page";
export const RIGHT_BUTTON_TEXT = "Move Away";
export const CONFIRMATION_MESSAGE =
  "Your changes will be lost if you move away from this page. Do you wish to move away from this page?";
